import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Zap, Construction } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="border-b border-border">
        <div className="container flex items-center justify-between h-16 px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg gradient-primary flex items-center justify-center">
              <Zap className="w-5 h-5 text-primary-foreground" />
            </div>
            <span className="font-display text-xl font-bold tracking-tight">Reqqy</span>
          </Link>
          <Button asChild variant="ghost" size="sm">
            <Link to="/home">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 rounded-2xl bg-muted flex items-center justify-center mx-auto mb-6">
            <Construction className="w-10 h-10 text-muted-foreground" />
          </div>
          <h1 className="text-3xl font-display font-bold mb-4">Coming Soon</h1>
          <p className="text-muted-foreground mb-8">
            We're working hard to bring you this feature. Check back soon for updates!
          </p>
          <Button asChild className="gradient-primary text-primary-foreground">
            <Link to="/">Return to Home</Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
